<template>
  <div class="game-render">
    <div id="iframe-parent" ref="gameRef" style="text-align: center;width: 100%">
      <iframe ref="iframe" id="iframe" class="game-iframe" :style="iframeStyle" src="http://game2.kjt61.com"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "gameRender",
  props: {
    problemInfo: {
      type: Object,
      default: null
    },
    userHomeworkResult: {
      type: Object,
      default: null
    }
  },
  components: {},
  data() {
    return {
      iframeStyle: {
        width: "1280px",
        height: "720px"
      },
      iframeWin: {},
      code: null,
      gameLoading: false,
      gameStatus: 3,
      gameSceneLoading: false
    }
  },
  created() {
    let winDoc = document.documentElement;
    this.setIframe(winDoc.clientWidth, winDoc.clientHeight);
    window.onresize = () => {
      return (() => {
        this.setIframe(winDoc.clientWidth, winDoc.clientHeight);
      })()
    };
  },
  mounted() {
    window.removeEventListener('message', this.notifyMessage)
    window.addEventListener('message', this.notifyMessage) // 添加监听
    this.iframeWin = this.$refs.iframe.contentWindow // 获取iframe信息
  },
  watch: {
    problemInfo() {
      if(window.myUnityInstance){
        this.gameLoadingLevelScene()
      }
    },
    userHomeworkResult(val) {
      console.log(val)
      if(val && this.code !== val.result.code && !this.gameSceneLoading){
        this.code = val.result.code
        this.gameInitCode(this.code)
      }
    }
  },
  methods: { // 接收通知
    notifyMessage(event) {
      const data = event.data
      console.log(data, 'message')
      if (data.cmd === 1) this.gameLoadingCompleted(data.params); // 游戏加载完毕通知
      else if (data.cmd === 2) this.gameOverNotifyCode(data.params); // 游戏结束代码通知
      else if (data.cmd === 3) this.gameOverNotifyGamePass(data.params); // 游戏结束通关状态通知
      else if (data.cmd === 4) this.gameLoadingLevelSceneCompleted(data.params); // 场景切换成功通知
    },
    // 游戏界面加载完成
    gameLoadingCompleted(msg) {
      this.gameLoadingLevelScene()
      window.myUnityInstance = true
    },
    // 游戏结束，通知代码
    gameOverNotifyCode(code) {
      this.code = code
    },
    // 游戏结束，通知通关状态：1为失败，2为1颗星，3为2颗星，4为完美通过
    gameOverNotifyGamePass(msg) {
      this.$emit('commitResult', {
        codeContent: this.code,
        language: 1,
        result: msg.result
      }); // 游戏结束，提交代码
    },
    gameInitCode(code) { // 通知游戏初始化代码
      this.iframeWin.postMessage({
        cmd: 'SetPlayerCodeContent',
        params: {
          code: code
        }
      }, '*')
    },
    gameLoadingLevelScene() { // 通知游戏切换关卡
      this.gameLoading = true
      this.gameSceneLoading = true
      this.iframeWin.postMessage({
        cmd: 'LoadScene',
        params: {
          level: this.problemInfo.problem.level
        }
      }, '*')
    },
    gameLoadingLevelSceneCompleted(data) {
      if (this.userHomeworkResult) {
        this.code = this.userHomeworkResult.result.code
        this.gameInitCode(this.code)
      }
      this.gameLoading = false;
      this.gameSceneLoading = false
    },
    setIframe(winWidth, winHeight) {
      let gameWidth = winWidth - 60;
      let gameHeight = winHeight - 105 - 60 - 76 - 20;
      let ratioHeight = gameWidth * 9 / 16;
      let ratioWidth = gameHeight * 16 / 9;
      if (gameWidth <= ratioWidth) {
        this.iframeStyle = {
          width: gameWidth + "px",
          height: ratioHeight + "px"
        }
      } else {
        this.iframeStyle = {
          width: ratioWidth + "px",
          height: gameHeight + "px"
        }
      }
    },
    gameQuit(f) {
      this.iframeWin.postMessage({
        cmd: 'QuitGame'
      }, '*')
      f()
    }
  }
}
</script>

<style lang="scss" scoped>
.game-render {
  .game-iframe {
    border: 2px solid #65B8B7;
    border-radius: 8px;
  }
}
</style>
